import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-leadership-certificates',
  templateUrl: './sales-leadership-certificates.component.html',
  styleUrls: ['./sales-leadership-certificates.component.scss']
})
export class SalesLeadershipCertificatesComponent {

}
